<div class="flex flex-col">
    <label class="text-base font-medium" [for]="config?.id">{{
        config?.label
    }}</label>
    <ng-template [ngIf]="!control" [ngIfElse]="reactiveFormField">
        <select class="rounded-lg" [id]="config?.id">
            <option
                *ngIf="!!config?.placeholder"
                [ngValue]="undefined"
                disabled
                hidden
            >
                {{ config?.placeholder }}
            </option>
            <option *ngFor="let option of options" [ngValue]="option.id">
                {{ option.value }}
            </option>
        </select>
    </ng-template>
    <ng-template #reactiveFormField>
        <select class="rounded-lg" [id]="config?.id" [formControl]="control">
            <option
                *ngIf="!!config?.placeholder"
                [ngValue]="undefined"
                disabled
                hidden
            >
                {{ config?.placeholder }}
            </option>
            <option *ngFor="let option of options" [ngValue]="option.id">
                {{ option.value }}
            </option>
        </select>
    </ng-template>
</div>
